import CryptoJS from "crypto-js";

/**
 * Encrypt with PHP, Decrypt with Javascript (cryptojs)
 * https://stackoverflow.com/a/27582253/9868383
 */
const CryptoJSAesJson = {
  stringify: function (cipherParams) {
    var j = { ct: cipherParams.ciphertext.toString(CryptoJS.enc.Base64) };
    if (cipherParams.iv) j.iv = cipherParams.iv.toString();
    if (cipherParams.salt) j.s = cipherParams.salt.toString();
    return JSON.stringify(j);
  },
  parse: function (jsonStr) {
    var j = JSON.parse(jsonStr);
    var cipherParams = CryptoJS.lib.CipherParams.create({
      ciphertext: CryptoJS.enc.Base64.parse(j.ct)
    });
    if (j.iv) cipherParams.iv = CryptoJS.enc.Hex.parse(j.iv);
    if (j.s) cipherParams.salt = CryptoJS.enc.Hex.parse(j.s);
    return cipherParams;
  }
};

/**
 * crypt
 * @param {Object} body
 * @returns {String} query crypted
 */
export const crypt = (body) => {
  const bodyString = JSON.stringify(body);

  const data = CryptoJS.AES.encrypt(JSON.stringify(bodyString), "123456", {
    format: CryptoJSAesJson
  }).toString();

  return data;
  // return data;
};

/**
 * decrypt
 * @param {Object} body
 * @returns {String} query crypted
 */
export const decrypt = (encrypted) => {
  const data = CryptoJS.AES.decrypt(encrypted, "123456", {
    format: CryptoJSAesJson
  }).toString(CryptoJS.enc.Utf8);

  return data;
  // return data;
};

/**
 * monthsFormated
 * @param {Integer} month
 * @returns {String}
 */
export const monthsFormated = (month = 1) => {
  return month < 10 ? `0${month}` : month;
};

/**
 * formatVarcharDate
 * @param {String} fullDate ejem. 2024--
 * @returns ejem. -/-/2014
 */
export const formatVarcharDate = (fullDate = "--") => {
  if (!fullDate) {
    return "-/-/-";
  }
  const splittedFullDate = fullDate.split("-");

  const anio = splittedFullDate[0] || "-";
  const mes = splittedFullDate[1] || "-";
  const dia = splittedFullDate[2] || "-";

  return dia + "/" + mes + "/" + anio;
};

export const calculaTotalRecapitulacion = (recapitulaciones = []) => {
  let total = {
    porcentaje: 0,
    atc: 0,
    acc: 0,
    aoic: 0
  };

  recapitulaciones.forEach((item) => {
    total.porcentaje = total.porcentaje + parseFloat(item.porcentaje);
    total.atc = total.atc + parseFloat(item.areaterrenocomun);
    total.acc = total.acc + parseFloat(item.areaconstruidacomun);
    total.aoic = total.aoic + parseFloat(item.areaotrainstalacioncomun);
  });

  return total;
};
